import { render } from "./MenuTableCellInputUpDownBox.vue?vue&type=template&id=70aa95fa"
import script from "./MenuTableCellInputUpDownBox.vue?vue&type=script&lang=js"
export * from "./MenuTableCellInputUpDownBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__